<div class="content" [id]="firstSchemaId">
  <div class="content__container">
    <div class="content__container_regular">
      <div class="content__title initial-fade-up-animate">
        <h2 class="content__title_text">
          <span class="gradient-span">Riddick's Partners</span>
          <span> {{ 'main.isMatch' | translate }} </span>
          <span class="gradient-span">{{ 'main.innovationAndYearsOfexperience' | translate }}</span>
          <span> {{ 'main.inAffiliateMarketing' | translate }}</span>
        </h2>
        <p class="headline-regular">{{ 'main.weTurnChallanges' | translate }}</p>
      </div>
    </div>

    <div class="content__schemas">
      <div class="content__schemas_container">
        <div class="content__schemas_grid" data-aos="fade-up">
          <div class="content__schemas_schema content__schemas__1">
            <rp-home-native-speaking-support-schema />
          </div>

          <div class="content__schemas_schema content__schemas__2">
            <rp-home-statistics-detailing-schema />
          </div>

          <div class="content__schemas_schema content__schemas__3">
            <rp-home-expertise-exchange />
          </div>

          <div class="content__schemas_schema content__schemas__4">
            <rp-home-seo-optimization-schema />
          </div>

          <div class="content__schemas_schema content__schemas__5">
            <rp-home-fast-performance-schema />
          </div>

          <div class="content__schemas_schema content__schemas__6">
            <rp-home-gift-shop-schema />
          </div>

          <div class="content__schemas_schema content__schemas__7">
            <rp-home-legal-support-schema />
          </div>

          <div class="content__schemas_schema content__schemas__8 content__schemas__handy-tools">
            <rp-home-handy-tools-schema />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
